import { caseInsensitiveSort } from '@/lib/sort';
import type { Mention, State } from './types';

export type Mutation =
  | { type: 'setMentions'; data: Mention[] }
  | { type: 'addMention'; data: Mention }
  | { type: 'replaceMention'; data: Mention }
  | { type: 'dismissMention'; id: string };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setMentions':
      return setMentions(state, action);
    case 'replaceMention':
      return replaceMention(state, action);
    case 'addMention':
      return addMention(state, action);
    case 'dismissMention':
      return dismissMention(state, action);
    default:
      return state;
  }
}

function setMentions(_state: State, { data }: { data: Mention[] }): State {
  const all = data.sort(caseInsensitiveSort(['data.created_at']));

  return {
    loaded: true,
    list: all,
  };
}

function addMention(state: State, { data }: { data: Mention }): State {
  const newList = [...state.list, data];

  return {
    ...state,
    list: newList.sort(caseInsensitiveSort(['data.created_at'])),
  };
}

function dismissMention(state: State, { id }: { id: string }): State {
  return {
    ...state,
    list: state.list.filter((item: Mention) => item.id !== id),
  };
}

function replaceMention(state: State, { data }: { data: Mention }): State {
  const index = state.list.findIndex((item: Mention) => item.id === data.id);
  if (index === -1) {
    return state;
  }

  const newList = [
    ...state.list.slice(0, index),
    data,
    ...state.list.slice(index + 1),
  ];

  return {
    ...state,
    list: newList,
  };
}
